/**
 * Which search key the GearFocus Algolia app (88N6DHABGH) uses on this side of
 * the wire (web#1902, web#1223).
 *
 * Browser bundles get NEXT_PUBLIC_ALGOLIA_PUBLIC_SEARCH_KEY: search-only,
 * limited to the public indexes, and limited to gearfocus.com and Vercel
 * preview referers. Server code (getServerSideProps, API routes, cron jobs)
 * sends no Referer header, so Algolia refuses that key there; it uses
 * ALGOLIA_SERVER_SEARCH_KEY instead (same indexes, no referer limit). The
 * server key has no NEXT_PUBLIC_ prefix, so Next.js never inlines it into a
 * client chunk; in the browser that reference reads as undefined.
 *
 * Deliberately no hardcoded fallback: a literal fallback is how a key rotation
 * looks finished while the old key is still in use. A missing variable yields
 * '' so Algolia rejects the call, and the error below names which variable.
 */
export const GF_ALGOLIA_APP_ID = '88N6DHABGH';

let warnedMissing = false;

export function gfAlgoliaSearchKey(
  isServer: boolean = typeof window === 'undefined'
): string {
  const key = isServer
    ? process.env.ALGOLIA_SERVER_SEARCH_KEY
    : process.env.NEXT_PUBLIC_ALGOLIA_PUBLIC_SEARCH_KEY;
  if (!key && !warnedMissing) {
    warnedMissing = true;
    console.error(
      `[algolia] ${
        isServer ? 'ALGOLIA_SERVER_SEARCH_KEY' : 'NEXT_PUBLIC_ALGOLIA_PUBLIC_SEARCH_KEY'
      } is not set; GearFocus search will return no results.`
    );
  }
  return key ?? '';
}
